import type { ChartExportRequest } from '@emr/shared';

import { requestBlob } from './client.ts';

/**
 * `POST /api/patients/:patientId/export` (`BACKLOG.md` C22, staff-facing half) — returns the
 * generated PDF as a `Blob`, not JSON, so this goes through `client.ts`'s `requestBlob` rather than
 * `apiRequest`. The server's own failure envelope (`chart_access_denied`, `not_found`,
 * `invalid_request`, `forbidden`, `audit_unavailable` — `@emr/shared`'s `CLINICAL_ERROR_CODES`) is
 * still JSON either way, so `requestBlob` maps a non-2xx response to the identical `ApiError` shape
 * every other page in this app already handles.
 */
export async function exportChart(patientId: string, request: ChartExportRequest): Promise<Blob> {
  return requestBlob(`/api/patients/${patientId}/export`, { body: request });
}
